module.exports = __webpack_public_path__ + "static/img/icon_help.9133271b.png";